export enum Step {
    SelectBank = 0,
    Redirect = 1,
    SelectBankIdMethod = 2,
    DecoupledOtherDevice = 3,
    DecoupledSameDevice = 4,
    ActiveBankId = 5,
}

export type OpenBankingAccountsSidebarProps = {
    /*** Preselected affiliated bank. */
    affiliatedBankId?: string | null;
    /*** Preselected bank. */
    bic?: string | null;
    onCancel: () => void;
    onUserVerify: () => void;
    visible: boolean;
};
